import React from 'react';
import { BadgeGroup } from './BadgeGroup';
import { useAuth } from 'lib/auth';

export const Badges = ({firstName}) => {
  
  return (
    <div className='bg-white/10 p-4 rounded-xl'>
      <div className="text-white font-semibold mb-3">Archievements</div>
      <div className="text-white text-sm mb-3">
        Check out {firstName}'s achievements so far. Users can gain earn badges through interaction with the wire24 app.
      </div>
      <BadgeGroup />
    </div>
  );
};
